import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DialogOverlayContainer extends OverlayContainer {
  getRootElement(): HTMLElement {
    return this._document.querySelector(`app-root`) as HTMLElement;
  }

  protected override _createContainer(): void {
    const container: HTMLDivElement = document.createElement('div');
    container.classList.add('app-overlay-container');

    const element = this._document.querySelector(`app-root`) as HTMLElement;

    if (element !== null) {
      element.after(container);
      this._containerElement = container;
    }
  }
}
